import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/landing.css';
import '../../styles/route.css';
import Logo from '../common/Logo';

const Footer: React.FC = () => {
  return (
    <footer className="landing-footer sw-on-dark">
      <div className="container">
        <div className="landing-footer-grid">
          <div className="landing-footer-brand-block">
            <div className="landing-footer-brand">
              <Logo size={36} variant="inverted" />
            </div>
            <p className="landing-footer-copy">
              Book a bakkie or truck when you need one — for a move, a delivery, or a
              business load. Vetted drivers, and the price up front.
            </p>
            <div className="landing-footer-tagline">
              Too big for the car? Book a bakkie.
            </div>
          </div>

          <div>
            <h2 className="landing-footer-title">Use Cases</h2>
            <ul className="landing-footer-list">
              {/* Absolute hashes and router links: the footer renders on every
                  page, and a bare "#solutions" resolves against whatever page
                  the reader is on rather than the homepage section. */}
              <li><Link className="landing-footer-link" to="/#solutions">Home Moves</Link></li>
              <li><Link className="landing-footer-link" to="/#solutions">Retail Deliveries</Link></li>
              <li><Link className="landing-footer-link" to="/#business">Corporate Fleet Backup</Link></li>
              <li><Link className="landing-footer-link" to="/#drivers">Driver Opportunities</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="landing-footer-title">Platform</h2>
            <ul className="landing-footer-list">
              <li><Link className="landing-footer-link" to="/about">About Us</Link></li>
              <li><Link className="landing-footer-link" to="/about#contact">Contact Us</Link></li>
              <li><Link className="landing-footer-link" to="/register">Create Account</Link></li>
              <li><Link className="landing-footer-link" to="/login">Log In</Link></li>
              <li><Link className="landing-footer-link" to="/how-it-works">How It Works</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="landing-footer-title">Legal</h2>
            <ul className="landing-footer-list">
              <li><Link className="landing-footer-link" to="/privacy">Privacy Policy</Link></li>
              <li><Link className="landing-footer-link" to="/terms">Terms of Service</Link></li>
              <li><Link className="landing-footer-link" to="/data-deletion">Data Deletion</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="landing-footer-title">Contact</h2>
            <ul className="landing-footer-list landing-footer-list-static">
              <li><a className="landing-footer-link" href="mailto:siyamcela@shiftwagon.co.za">siyamcela@shiftwagon.co.za</a></li>
              <li><a className="landing-footer-link" href="tel:+27766330175">+27 76 633 0175</a></li>
              <li>Administered by Mike Innovations (Pty) Ltd</li>
              <li>South Africa focused</li>
            </ul>
          </div>
        </div>

        <div className="landing-footer-meta">
          &copy; {new Date().getFullYear()} Mike Innovations (Pty) Ltd. All rights reserved.
          Johannesburg, Gauteng, South Africa
        </div>
      </div>
    </footer>
  );
};

export default Footer;
